import { createApi, fakeBaseQuery, SkipToken } from "@reduxjs/toolkit/dist/query/react";
import { collection, doc, getDocs, setDoc } from "firebase/firestore";
import { db } from "@/firebase";
import { setUserAccess } from "@/features/auth/slice";
import { OrgAccess } from "@/types";
import { ApiError } from "@/types/api";
import { RootState } from "@/store/store";

export const accessApi = createApi({
  reducerPath: "userAccess",
  baseQuery: fakeBaseQuery<ApiError>(),
  tagTypes: ["userAccess"],
  endpoints: (builder) => ({
    fetchAccess: builder.query<OrgAccess[], string | SkipToken>({
      queryFn: async (userId, { dispatch }) => {
        const collectionRef = collection(db, `users/${String(userId)}/access`);

        const response = await getDocs(collectionRef).then((querySnapshot) => {
          return querySnapshot.docs.reduce((acc, doc: any) => {
            return [...acc, { ...doc.data(), id: doc.id }];
          }, [] as OrgAccess[]);
        });

        if (response.length) {
          dispatch(setUserAccess(response));

          return {
            data: response,
          };
        }

        return {
          error: {
            status: 404,
            statusText: "Accesos no encontrados",
          },
        };
      },
      providesTags: ["userAccess"],
    }),
    createAccess: builder.mutation<OrgAccess, { organizationId: string; organizationTitle: string } | SkipToken>({
      queryFn: async ({ organizationId, organizationTitle }, { getState }) => {
        const { auth } = getState() as RootState;

        if (!auth?.user?.uid) {
          return {
            error: {
              status: 401,
              statusText: "No autorizado",
            },
          };
        }

        const docRef = doc(db, `users/${String(auth?.user?.uid)}/access/${String(organizationId)}`);

        try {
          await setDoc(docRef, {
            role: "admin",
            title: organizationTitle,
          });

          return {
            data: organizationId,
          };
        } catch {
          return {
            error: {
              status: 500,
              statusText: "Error al crear el acceso",
            },
          };
        }
      },
      invalidatesTags: ["userAccess"],
    }),
  }),
});

export const { useFetchAccessQuery, useLazyFetchAccessQuery, useCreateAccessMutation } = accessApi;
